export default __webpack_public_path__ + "static/media/image_50802177.afda1ed0.jpg";